import { Component, OnInit, Input, ViewChild,Inject} from '@angular/core';
import {MatPaginator, MatDialog,MatTableDataSource,MAT_DIALOG_DATA,MatDialogRef} from '@angular/material';

import { LoggedinService } from '../../../services/login/loggedin.service';
import { TasksService } from '../../../services/tasks/tasks.service';
import { SessionHelper } from '../../../shared/services/localstorage';
import { roleID } from '../../../configurations/configuration';
import { EventService } from '../../../services/event/event.service';
import { SuccessDialogComponent } from "../../../shared/success-dialog/success-dialog";
import * as moment from 'moment';


@Component({
  selector: 'app-email-preivew',
  templateUrl: './email-preview.component.html',
  styleUrls: ['./email-preview.component.scss']
})
export class EmailPreviewComponent implements OnInit {

  _taskData = [];
  showLoader: boolean = true;
  roleID = roleID;
  taskDataFiltered = [];
  attendeeName:any="";
  webinarURL:any="";
  @Input() isViewAll;
  @Input() set taskData(value: any) {
    this._taskData = value;
    console.log(this._taskData);
    if(this._taskData.length >= 0) {
      this.showLoader = false;
      this.taskDataFiltered = [];
      this._taskData.forEach(element => {
        if(this.role!==roleID.SALES_REP_ROLE_ID) {
          this.taskDataFiltered.push(element);
        }
        else if((this.role === roleID.SALES_REP_ROLE_ID || this.role === roleID.MARKETING_ROLE_ID)  && element.taskTitle !== 'Reconcile Event') {
          this.taskDataFiltered.push(element);
        }
      })
      // this.taskDataFiltered = this._taskData;
    }
    else {
      this.showLoader = false;
    }
  }
  get taskData(): any {
    // other logic
    return this.taskDataFiltered;
  }
  pageSize: number = 10;
  pageNumber: number = 1;
  totalRecords: number;
  filterObj = {};
  user: any;
  eventDate:any;
  formattedDate:any;
  timeZone:any;
  eventTime:any;
  role: number;
  link1:any="";
  link2:any="";
  link3:any="";
  link4:any="";
  attendeeEmail:any="";
  meetingTypeId="";
  VenueCity="";
  VenueState="";
  topicName="";
  registrationTime="";
  TimeZone="";
  VenueName="";
  VenueAddress="";
  VenueZip="";
  allEventData:any;
  logistics="[Logistics: re: parking etc.]";

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,      private dialog: MatDialog, 
  private eventService:EventService,
  public loggedInService: LoggedinService, private tasksService: TasksService,public dialogRef: MatDialogRef<EmailPreviewComponent>) { }

  ngOnInit() { 
    console.log(">>>>>>Data",this.data);
    
    console.log(">>>>>>Data",this.data.data);
    console.log(">>>>>>Data",this.data.data.attendeeName);
    let tryy = this.data.data.attendeeName.split(' ')
    this.attendeeName = tryy[0];
    this.webinarURL = this.data.data.webinarURL;
    this.eventDate = this.data.data.eventDate;

    // let temp1 = moment(this.data.data.eventDate, "MM-DD-YYY").format('dddd, LL');
    // let dayOfWeek = temp1.split(',')[0];
    // let month = temp1.split(',')[1].split(' ')[1];
    // let year = moment(this.data.data.eventDate, "MM-DD-YYY").format('YYYY');

    this.formattedDate = moment(this.data.data.eventDate, "MM-DD-YYYY").format('LL')
    this.eventTime = this.data.data.eventTime;
    this.attendeeEmail = this.data.data.attendeeEmail;
    this.timeZone = this.data.data.timeZone;
    this.allEventData = this.data.data.allEventData;
    this.registrationTime = this.data.data.registrationTime;
    this.meetingTypeId = this.data.data.meetingTypeId;

    this.showLoader = true;
    this.user = SessionHelper.getSession();
    console.log(this.user)
    this.filterObj = {
      userId: this.user.id,
      brandId: this.user.brand_id
    }  
    console.log(this.filterObj);
    this.user = SessionHelper.getSession();
    this.role = this.user.role_id;
    console.log(this.role);
    this.filterObj = {
      userId: this.user.id,
      brandId: this.user.brand_id
    } 
  }

  sendEmail(){
    
    let postBody = {
      "link1":this.link1,
      "link2":this.link2,
      "link3":this.link3,
      "link4":this.link4,
      "attendeeName":this.attendeeName,
      "webinarURL":this.webinarURL,
      "eventDate":this.eventDate,
      "eventTime":this.eventTime,
      "attendeeEmail":this.attendeeEmail,
      "timeZone":this.timeZone,
      "meetingTypeId":this.meetingTypeId,
      "allEventData":this.allEventData,
      "registrationTime":this.registrationTime,
      "logistics":this.logistics
    }

    this.eventService.sendAttendeeInvite(postBody)
    .subscribe((result:any)=>{

      const dialogReff = this.dialog.open(SuccessDialogComponent, { disableClose: true });
      dialogReff.componentInstance.successMessage = 'Reminder Email Sent Successfully!';
      dialogReff.componentInstance.title = 'Success';

      this.dialogRef.close();


    });

  }

  pageChanged(pN: number): void {
    this.pageNumber = pN;
  }
}
